import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import { store } from "../store";



export function getDistricts() {

  const { dispatch } = store;
  CommonAxiosGet(config.url.API_URL + "getdistricts").then((res) => {
    if (res !== undefined) {

      dispatch({ type: "DISTRICTLIST", payload: res?.data?.districtmst });

      return dispatch({ type: "DISTRICTLIST", payload: res?.data?.districtmst });
    }
  })
}

export function getDistrictsTest() {

  const { dispatch } = store;
  CommonAxiosGet(config.url.API_URL + "getdistricts").then((res) => {
    if (res !== undefined) {

      dispatch({ type: "DISTRICTLIST_MultiField", payload: res?.data?.districtmst });

      return dispatch({ type: "DISTRICTLIST_MultiField", payload: res?.data?.districtmst });
    }
  })
}

export const getMandals = (distCode, dispatch, targetField) => {
  if (distCode === undefined || distCode === "" || distCode === null) {
    dispatch({ type: "MANDALSLIST", payload: [] });
    dispatch({ type: "VILLAGESLIST", payload: [] });

  } else {

    CommonAxiosGet(config.url.API_URL + "getmandals/" + distCode).then((res) => {
      if (res !== undefined) {
        if (targetField === "societyHeadDist") {
          dispatch({ type: "MANDALSLIST_MultiField", payload: res.data.mandalmst });
        }
        else {
          dispatch({ type: "MANDALSLIST", payload: res.data.mandalmst });
        }

      }
      else {
        if (targetField === "societyHeadDist") {
          dispatch({ type: "MANDALSLIST_MultiField", payload: [] });
        }
        else {
          dispatch({ type: "MANDALSLIST", payload: [] });
          dispatch({ type: "VILLAGESLIST", payload: [] });

        }

      }
    });
  }
}


export const getVillages = (distCode, mandalCode, dispatch, targetField) => {
  console.log("distCode", distCode, "mandalCode", typeof mandalCode)
  // if ((distCode === undefined || distCode === "" || distCode === null) && (mandalCode === undefined || mandalCode === "" || mandalCode === null)) {
  //   dispatch({ type: "VILLAGESLIST", payload: [] });
  if (!distCode || !mandalCode) {
    dispatch({ type: "VILLAGESLIST", payload: [] });
    return; // exit early, no URL hit

  } else {
    dispatch({ type: 'SHOW_SPINNER', payload: true });
    let Url = config.url.API_URL + "getvillages/" + distCode + "/" + mandalCode;
    console.log("url", Url)

    CommonAxiosGet(Url).then((res) => {
      dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
      if (res !== undefined) {
        if (targetField === "societyDist") {
          dispatch({ type: "VILLAGELIST_MultiField", payload: res?.data?.villagemst });
        }
        else {
          dispatch({ type: "VILLAGESLIST", payload: res?.data?.villagemst });
        }

      }
      else {
        if (targetField === "societyDist") {
          dispatch({ type: "VILLAGELIST_MultiField", payload: [] });
        }
        else {
          dispatch({ type: "VILLAGESLIST", payload: [] });
        }

      }
    });
  }
}

export const gethabitationlist = (distCode, mandalCode, dispatch) => {
  if ((distCode === undefined || distCode === "" || distCode === null) && (mandalCode === undefined || mandalCode === "" || mandalCode === null)) {
    dispatch({ type: "HabitationLIST", payload: [] });
  } else {
    dispatch({ type: 'SHOW_SPINNER', payload: true });
    let Url = config.url.API_URL + "gethabitationlist/" + distCode + "/" + mandalCode;

    CommonAxiosGet(Url).then((res) => {
      dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
      if (res !== undefined) {
        dispatch({ type: "HabitationLIST", payload: res?.data?.habitationlist });
      }
    });
  }
}
export function getCollNaturelist() {
  const { dispatch } = store;
  let Url = config.url.API_URL + "getCollNaturelist";
  CommonAxiosGet(Url).then((res) => {
    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      dispatch({ type: "CollNatureLIST", payload: res?.data?.CollNaturelist });
    }
  });
}
export function getReligions() {
  const { dispatch } = store;
  let Url = config.url.API_URL + "getReligions";
  CommonAxiosGet(Url).then((res) => {
    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      dispatch({ type: "ReligionList", payload: res?.data?.Religions });
    }
  });
}
export function getCasts(religion) {
  const { dispatch } = store;
  let Url = config.url.API_URL + "getCasts/" + religion;
  CommonAxiosGet(Url).then((res) => {
    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      dispatch({ type: "Casts", payload: res?.data?.Casts });
    }
  });
}
export function getDesignations() {
  const { dispatch } = store;
  let Url = config.url.API_URL + "getDesignations";
  CommonAxiosGet(Url).then((res) => {
    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      dispatch({ type: "Designations", payload: res?.data?.Designations });
    }
  });
}
export function getEmpTypes() {
  const { dispatch } = store;
  let Url = config.url.API_URL + "getEmpTypes";
  CommonAxiosGet(Url).then((res) => {
    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      dispatch({ type: "EmpTypes", payload: res?.data?.EmpTypes });
    }
  });
}
export function getQualifications() {
  const { dispatch } = store;
  let Url = config.url.API_URL + "getQualifications";
  CommonAxiosGet(Url).then((res) => {
    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      dispatch({ type: "Qualifications", payload: res?.data?.Qualifications });
    }
  });
}

export const getCourses = () => {
  const { dispatch } = store;

  dispatch({ type: 'SHOW_SPINNER', payload: true });
  let Url = config.url.API_URL + "getCourses";
  CommonAxiosGet(Url).then((res) => {
    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      dispatch({ type: "Courses", payload: res?.data?.Courses });
    }
  });

};
export const GetDesignations = () => {
  const { dispatch } = store;

  dispatch({ type: 'SHOW_SPINNER', payload: true });
  let Url = config.url.API_URL + "getDesignationList";
  CommonAxiosGet(Url).then((res) => {
    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      dispatch({ type: "DisignationList", payload: res?.data?.getDesignationList });
    }

  })
}

export const GetDepartments = () => {
  const { dispatch } = store;

  dispatch({ type: 'SHOW_SPINNER', payload: true });
  let Url = config.url.API_URL + "getdeptList";
  CommonAxiosGet(Url).then((res) => {

    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      dispatch({ type: "DepartmentList", payload: res?.data?.getdeptList });
    }

  })
}
export const GetSubjectList = () => {
  const { dispatch } = store;

  dispatch({ type: 'SHOW_SPINNER', payload: true });
  let Url = config.url.API_URL + "getubList";
  CommonAxiosGet(Url).then((res) => {

    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      dispatch({ type: "SubList", payload: res?.data?.getubList });
    }

  })
}
export const GetMediumList = () => {
  const { dispatch } = store;
  dispatch({ type: 'SHOW_SPINNER', payload: true });
  let Url = config.url.API_URL + "getMediumList";
  CommonAxiosGet(Url).then((res) => {
    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      dispatch({ type: "MEDIUM", payload: res?.data?.getMediumList });
    }

  })
}

export const GetStatusFlags = (year, collcode) => {
  const { dispatch } = store;
  dispatch({ type: 'SHOW_SPINNER', payload: true });
  const url = `${config.url.API_URL}getAfflOrderVerif/${collcode}/${year}`
  CommonAxiosGet(url).then((res) => {
    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      dispatch({ type: "STATUS", payload: res?.data });
    }
  })
}

export const GetCollegeType = () => {
  const { dispatch } = store;
  dispatch({ type: 'SHOW_SPINNER', payload: true });
  const url = `${config.url.API_URL}clgType`
  CommonAxiosGet(url).then((res) => {
    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      dispatch({ type: "COLLEGETYPE", payload: res?.data });
    }
  })
}

export const GetFFCAStatus = (colcode, acYear) => {
  const { dispatch } = store;
  dispatch({ type: 'SHOW_SPINNER', payload: true });
  let url = config.url.API_URL + `ffcaStatus/` + colcode + "/" + acYear;
  CommonAxiosGet(url).then((res) => {
    dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
    if (res !== undefined) {
      dispatch({ type: "FFCA_STATUS", payload: res?.data?.ffcaStatus });
    }
  })
}




